import type { VChartSpecPipeline } from 'src/types'
import {
  initPie,
  pieGeometry,
  backgroundColor,
  tooltip,
  discreteLegend,
  color,
  pieStyle,
  pieHover,
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  progressive,
  colorAdapter,
  linearColor,
  colorLegend,
  brush,
  colorPieStyleFill,
  labelPie,
  playerPie,
  annotationArea,
  datasetXY,
  isPlayer,
  fontFamilyTheme,
} from '../pipes'

const racePie: VChartSpecPipeline = [
  fontFamilyTheme,
  initPie,
  pieGeometry,
  colorAdapter(color, linearColor),
  backgroundColor,
  isPlayer(playerPie, datasetXY),
  progressive,
  brush,
  colorPieStyleFill(pieStyle),
  pieHover,
  colorAdapter(discreteLegend, colorLegend),
  labelPie,
  tooltip({ titleEncoding: 'color' }),
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationArea,
]

export const racePieSpecPipeline = racePie
